import redesign_plp from "./redesign-plp";

function observeChanges() {
  const targetNode = document.querySelector('#js-product-ajax .row.AjaxinateLoop');

  if (targetNode) {
    const observer = new MutationObserver((mutationsList, observer) => {
      for(let mutation of mutationsList) {
        if (mutation.type === 'childList') {
          redesign_plp()
        }
      }
    });

    const config = { attributes: false, childList: true, subtree: false };
    observer.observe(targetNode, config);
  }
}

export default observeChanges;
